import { AgGridModule } from '@ag-grid-community/angular';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from 'angularfire2';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ChartModule } from 'primeng/chart';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TabMenuModule } from 'primeng/tabmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';
import { PaginatorModule } from 'primeng/paginator';
import { TreeNode } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { CustomTooltipComponent } from './common/ag-component/customtooltip.component';
import { ListGridAngularModule } from './common/list-grid-angular/list-grid-angular.module';
import { DefaultLayoutPosComponent } from './containers/default-layout-pos/default-layout-pos.component';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { HomeComponent } from './pages/home/home.component';
import { ApiService } from './services/api.service';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthInterceptor } from './services/auth-interceptor';
import { AuthService } from './services/auth.service';
import { ExportFileService } from './services/export-file.service';
import { FirebaseAuthService } from './services/firebase-auth.service';
import { FeedBaseService } from './services/firebase.service';
import { FooterComponent } from './shared/footer/footer.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SharedCommonModule } from './shared/shared.module';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { DialogModule } from 'primeng/dialog';
import { NgIconsModule } from '@ng-icons/core';
import { MODULE_POPOVER_ICONS } from './shared/icons/module-popover-icons';
const APP_CONTAINERS = [DefaultLayoutComponent, DefaultLayoutPosComponent];
@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    HomeComponent,
    AuthCallbackComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    CustomTooltipComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    InputTextModule,
    SharedCommonModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    HttpClientModule,
    ToolbarModule,
    NgxSpinnerModule,
    SplitButtonModule,
    AvatarModule,
    BadgeModule,
    MenuModule,
    MenubarModule,
    NgxScannerQrcodeModule,
    TabMenuModule,
    DropdownModule,
    PaginatorModule,
    OverlayPanelModule,
    ToastModule,
    ConfirmDialogModule,
    TimelineModule,
    ChartModule,
    ListGridAngularModule,
    AgGridModule.withComponents([
      CustomTooltipComponent
    ]),
    TreeModule,
    TreeSelectModule,
    DialogModule,
    NgIconsModule.withIcons(MODULE_POPOVER_ICONS),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
        deps: [HttpClient]
      },
      defaultLanguage: 'vi'
    })
  ],
  providers: [
    AuthService,
    AuthGuardService,
    FirebaseAuthService,
    ApiService,
    ExportFileService,
    FeedBaseService,
    MessageService,
    ConfirmationService,
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
